import FilterHelper from "../../helpers/filterHelper";
import { formatQueryStringURL } from "../../helpers/formatQueryStringHelper";
import {
  axiosGet,
  axiosPatch,
  axiosPost,
  axiosPut,
} from "../../services/axiosService";

const loanURL = "/loans";
export class LoanService {
  createNewLoan(userID) {
    return axiosPost(null, loanURL + `/${userID}`, null);
  }

  getLoans(status, filter, currentPage = 1, perPage = 10, extraFilter) {
    let loanStatus = status?.toString()
      ? !isNaN(status)
        ? `status=${status}`
        : ""
      : "";
    let params = `${loanStatus}${
      filter ? `${FilterHelper.mapToParams(filter)}` : ""
    }&Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}${
      extraFilter ? "&" + extraFilter : ""
    }`;
    params = formatQueryStringURL("?" + params);
    return axiosGet(null, loanURL + params);
  }

  exportLoans = (status, filter = null) => {
    let loanStatus = status?.toString()
      ? !isNaN(status)
        ? `status=${status}`
        : ""
      : "";
    let params = `${loanStatus}${
      filter ? `${FilterHelper.mapToParams(filter)}` : ""
    }`;
    if (params) params = formatQueryStringURL("?" + params);

    console.log("Exporting loans url:", loanURL + "/export" + params);
    return axiosGet(null, loanURL + "/export" + params, null, "blob");
  };

  getLoanById(id) {
    return axiosGet(null, loanURL + `/${id}`);
  }

  getHistory(id) {
    return axiosGet(null, loanURL + `/${id}/history`);
  }

  getInvestors(userID) {
    return axiosGet(null, loanURL + `/${userID}/investors`);
  }

  exportInvestors(userID) {
    return axiosGet(null, `${loanURL}/${userID}/exportInvestors`, null, "blob");
  }

  updateInvestingMode(id, mode) {
    return axiosGet(null, loanURL + `/${id}/InvestingMode?mode=${mode}`);
  }

  updateLoanBaseInfo(id, value) {
    return axiosPut(value, loanURL + `/${id}`);
  }

  updateLoanParams(id, values) {
    return axiosPut(values, loanURL + `/${id}/parameters`);
  }

  getStatusHistory(id) {
    return axiosGet(null, loanURL + `/${id}/history`);
  }

  cancelLoanInvestments(loanId) {
    return axiosGet(null, loanURL + `/${loanId}/CancelInvestments`);
  }

  getLoanCountByStatus(status, isRestructured = false, isUpcoming = false) {
    return axiosGet(
      null,
      `${loanURL}/CountByStatus/${status}${
        isRestructured ? "?isRestructered=true" : ""
      }${isUpcoming ? "?upcomingEmi=true" : ""}`
    );
  }

  getUpcomingEMICount() {
    return axiosGet(null, `${loanURL}/CountUpcomingPaymentLoans`);
  }

  getAllLoanCount() {
    return axiosGet(null, `${loanURL}/CountAllLoans`);
  }

  reactivateLoan(loanId) {
    return axiosPatch(loanURL + `/${loanId}/Restore`);
  }

  updateStatusPreCredit(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/pre-credit`, {});
  }

  updateStatusCredit(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/credit`, {});
  }

  updateStatusPreCompliance(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/pre-compliance`, {});
  }

  updateStatusPreFundraising(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/pre-fundraising`, {});
  }

  updateStatusFullyFilled(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/fully-filled`, {});
  }

  updateStatusCreditAnalysis(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/credit-analysis`, {});
  }

  onCompliance(loanId, overrideAml = false) {
    return axiosPatch(loanURL + `/${loanId}/status/compliance`, {
      overrideAml,
    });
  }

  setFundraisingStatus(loanId, ignoreEmail = false) {
    return axiosPatch(
      loanURL + `/${loanId}/status/fundraising?ignoreEmails=${ignoreEmail}`,
      {}
    );
  }

  setDisburseStatus(loanId, shouldTransferMoney = true) {
    return axiosPatch(loanURL + `/${loanId}/status/Disburse`, { shouldTransferMoney });
  }

  setExpiredStatus(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/Expired`, {});
  }

  updateStatusFullyPaid(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/fully-paid`);
  }

  updateStatusLate(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/late`);
  }

  updateStatusDefault(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/default`);
  }

  updateStatusOnTime(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/on-time`);
  }

  updateStatusRejected(loanId) {
    return axiosPatch(loanURL + `/${loanId}/status/rejected`);
  }

  getUpcomingDisbursal(loanId) {
    return axiosGet(null, loanURL + `/${loanId}/TradeFlowDetails`);
  }

  getAecbLoanDetails(loanId) {
    return axiosGet(null, loanURL + `/${loanId}/aecbLoanDetails`);
  }

  updateRecordIds(loanId, model) {
    return axiosPut(model, loanURL + `/${loanId}/aecbLoanDetails`);
  }

  exportPreview(loanId) {
    return axiosGet(
      null,
      loanURL + `/${loanId}/auto-investment-preview/export`
    );
  }

  getLoanFlags(loanId) {
    return axiosGet(null, `/Loans/lynk/${loanId}/flags`);
  }

  createLynkOrder(loanId) {
    return axiosPost(null, `/Loans/lynk/${loanId}/Create`);
  }

  processLynkOrder(lynkOrderId) {
    return axiosPost(null, `/Loans/lynk/${lynkOrderId}/Process`);
  }

  completeLynkOrder(lynkOrderId) {
    return axiosPost(null, `/Loans/lynk/${lynkOrderId}/Complete`);
  }

  cancelLynkOrder(lynkOrderId) {
    return axiosPost(null, `/Loans/lynk/${lynkOrderId}/Cancel`);
  }

  getRequestSignatureFlags(loanId) {
    return axiosGet(null, `/Loans/${loanId}/request-signature/flags`);
  }

  requestSignature(loanId) {
    return axiosPost(null, `/Loans/${loanId}/request-signature`);
  }
}
